/**
 * Smart Cart Progress Module
 * Two-stage cart system: Stage 1 (minimum basket) → Stage 2 (Prime incentive)
 */
(function() {
  'use strict';

  var SmartCartProgress = {
    config: {
      minimumBasket: 99900,
      freeDeliveryThreshold: 199900,
      primeVariantId: null,
      deliveryRate: 399,
      primePrice: 1999
    },

    state: {
      cartTotal: 0,
      isPrime: false,
      isLegacyPrime: false,
      cartHasGifts: false,
      hasGiftingMerchandise: false,
      cartItemCount: 0,
      cartHasPrimeProduct: false,
      currentStage: 'STAGE_2',
      legacyFreeDelivery: false,
      previousStage: null,
      _refreshTimeout: null,
      _policyGeneration: 0
    },

    elements: {
      container: null,
      stage1: null,
      stage1Message: null,
      stage1Fill: null,
      stage2a: null,
      stage2aMessage: null,
      stage2aFill: null,
      stage2aSavings: null,
      stage2b: null,
      checkoutBtn: null,
      checkoutText: null,
      checkoutSubtotal: null,
      tooltip: null,
      tooltipContent: null,
      savingsLine: null,
      savingsAmount: null
    },

    /**
     * Initialize the Smart Cart system
     */
    init: function() {
      this.elements.container = document.getElementById('smart-cart-progress');
      if (!this.elements.container) return;

      // Read config from data attributes
      var data = this.elements.container.dataset;
      var configuredMinimum = Number(data.minimumBasket);
      this.config.minimumBasket = Number.isFinite(configuredMinimum) && configuredMinimum >= 0 ? configuredMinimum : 99900;
      this.config.freeDeliveryThreshold = parseInt(data.freeDeliveryThreshold) || 199900;
      this.config.primeVariantId = data.primeVariantId;
      this.config.deliveryRate = parseInt(data.deliveryRate) || 399;
      this.config.primePrice = parseInt(data.primePrice) || 1999;

      // Read initial state
      this.state.cartTotal = parseInt(data.cartTotal) || 0;
      this.state.isPrime = data.isPrime === 'true';
      this.state.isLegacyPrime = data.isLegacyPrime === 'true';
      this.state.cartHasGifts = data.cartHasGifts === 'true';
      this.state.hasGiftingMerchandise = data.hasGiftingMerchandise === 'true';
      this.state.cartItemCount = parseInt(data.cartItemCount, 10) || 0;
      this.state.cartHasPrimeProduct = data.cartHasPrimeProduct === 'true';
      this.state.currentStage = data.currentStage || 'STAGE_2';
      this.state.legacyFreeDelivery = data.legacyFreeDelivery === 'true';

      // Cache DOM elements - stages
      this.elements.stage1 = this.elements.container.querySelector('.smart-cart__stage1');
      this.elements.stage2a = this.elements.container.querySelector('.smart-cart__stage2a');
      this.elements.stage2b = this.elements.container.querySelector('.smart-cart__stage2b');

      // Cache stage1 child elements
      if (this.elements.stage1) {
        this.elements.stage1Message = this.elements.stage1.querySelector('.smart-cart__message');
        this.elements.stage1Fill = this.elements.stage1.querySelector('.smart-cart__progress-fill');
      }

      // Cache stage2a child elements
      if (this.elements.stage2a) {
        this.elements.stage2aMessage = this.elements.stage2a.querySelector('.smart-cart__message');
        this.elements.stage2aFill = this.elements.stage2a.querySelector('.smart-cart__progress-fill');
        this.elements.stage2aSavings = this.elements.stage2a.querySelector('.smart-cart__savings');
      }

      // Cache tooltip elements
      this.elements.tooltip = this.elements.container.querySelector('[data-tooltip-container]');
      this.elements.tooltipContent = this.elements.container.querySelector('[data-tooltip-content]');

      // Cache checkout elements
      this.elements.checkoutBtn = document.getElementById('checkoutButton');
      this.elements.checkoutText = document.querySelector('[data-checkout-text]');
      if (this.elements.checkoutBtn) {
        this.elements.checkoutSubtotal = this.elements.checkoutBtn.querySelector('[data-subtotal]');
      }

      // Cache footer savings elements
      this.elements.savingsLine = document.querySelector('[data-savings-line]');
      this.elements.savingsAmount = document.querySelector('[data-savings-amount]');

      // Bind event handlers
      this.bindEvents();

      // Initial render
      this.updateCheckoutButton();

      // A stored date still needs fresh availability validation on load. Otherwise
      // the Liquid-rendered minimum policy is authoritative and init is request-free.
      if (data.hasStoredDeliveryDate === 'true') this.scheduleRefresh(50, false);
    },

    /**
     * Bind event listeners
     */
    bindEvents: function() {
      var self = this;

      // Cart events
      document.addEventListener('cart:build', function() {
        self.scheduleRefresh(100);
      });

      document.addEventListener('cart:updated', function(evt) {
        var cart = evt && evt.detail && evt.detail.cart;
        if (cart) {
          self.updateFromCart(cart);
        } else {
          self.fetchCartAndUpdate();
        }
      });

      // Product added to cart (from PDP, quick add, etc.)
      document.addEventListener('ajaxProduct:added', function() {
        self.scheduleRefresh(150);
      });

      // Prime checkbox
      var checkbox = document.getElementById('SmartCartPrimeCheckbox');
      if (checkbox) {
        checkbox.addEventListener('change', function() {
          if (checkbox.checked) {
            self.addPrimeToCart();
          }
        });
      }

      // Pre-checkout redirect
      var cartDrawerForm = document.getElementById('CartDrawerForm');

      // [MULTIVERTICAL] Helper to store mode and return URL before pre-checkout
      function storeCheckoutContext() {
        var vertical = document.body.dataset.vertical || 'gifting';
        sessionStorage.setItem('checkoutMode', vertical);
        sessionStorage.setItem('checkoutReturnUrl', window.location.pathname + window.location.search);
      }

      if (this.elements.checkoutBtn) {
        this.elements.checkoutBtn.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          storeCheckoutContext();
          window.location.href = theme.routes.home.replace(/\/?$/, '/') + 'pages/pre-checkout';
        });
      }
      if (cartDrawerForm) {
        cartDrawerForm.addEventListener('submit', function(event) {
          event.preventDefault();
          event.stopPropagation();
          storeCheckoutContext();
          window.location.href = theme.routes.home.replace(/\/?$/, '/') + 'pages/pre-checkout';
        }, true);
      }

      // Info icon tooltips
      var infoIcons = this.elements.container.querySelectorAll('[data-tooltip]');
      infoIcons.forEach(function(icon) {
        icon.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggleTooltip(icon);
        });
      });

      // Close tooltip on click outside
      document.addEventListener('click', function(e) {
        if (!e.target.closest('[data-tooltip]') && !e.target.closest('[data-tooltip-container]')) {
          self.hideTooltip();
        }
      });
    },

    /**
     * Schedule a debounced cart refresh
     * Clears any pending refresh to prevent redundant fetches
     */
    scheduleRefresh: function(delay, invalidatePolicy) {
      if (invalidatePolicy !== false) this.invalidateMinimumPolicy();
      if (this.state._refreshTimeout) {
        clearTimeout(this.state._refreshTimeout);
      }
      var self = this;
      this.state._refreshTimeout = setTimeout(function() {
        self.state._refreshTimeout = null;
        self.fetchCartAndUpdate(true, invalidatePolicy === false);
      }, delay || 100);
    },

    /**
     * Fetch cart data and update state
     */
    fetchCartAndUpdate: function(policyAlreadyInvalidated, preservePolicyOnFailure) {
      var self = this;
      if (!policyAlreadyInvalidated) this.invalidateMinimumPolicy();
      var generation = this.state._policyGeneration;
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (generation !== self.state._policyGeneration) return;
          self.updateFromCart(cart, preservePolicyOnFailure);
        })
        .catch(function(err) {
          console.error('[SmartCart] Failed to fetch cart:', err);
          if (!preservePolicyOnFailure) self.failMinimumPolicy(generation);
        });
    },

    /** Start a new policy generation while retaining the last verified gift bit. */
    invalidateMinimumPolicy: function() {
      this.state._policyGeneration++;
    },

    /** Current failures conservatively clear the exemption; stale failures do nothing. */
    failMinimumPolicy: function(generation) {
      if (generation !== this.state._policyGeneration) return;
      this.state.hasGiftingMerchandise = false;
      this.state.currentStage = this.getCurrentStage();
      if (this.elements.container) {
        this.elements.container.dataset.hasGiftingMerchandise = 'false';
        this.elements.container.dataset.currentStage = this.state.currentStage;
      }
      this.render();
      this.updateCheckoutButton();
    },

    /**
     * A valid-but-mismatched section can represent an intermediate cart. Refetch
     * the complete cart once, then verify it against one fresh section response
     * under the same generation. Superseded generations become no-ops.
     */
    resyncMinimumPolicy: function(generation, preservePolicyOnFailure) {
      var self = this;
      fetch('/cart.js')
        .then(function(response) {
          if (generation !== self.state._policyGeneration) return null;
          return response.json();
        })
        .then(function(cart) {
          if (!cart || generation !== self.state._policyGeneration) return;
          self.updateFromCart(cart, preservePolicyOnFailure, {
            generation: generation,
            retriesRemaining: 0,
            suppressCelebration: true
          });
        })
        .catch(function(err) {
          if (generation !== self.state._policyGeneration) return;
          console.error('[SmartCart] Failed to resync cart policy:', err);
          if (!preservePolicyOnFailure) self.failMinimumPolicy(generation);
        });
    },

    cartFingerprint: function(cart) {
      return (cart.items || []).map(function(item) {
        return String(item.key || '') + ':' + String(parseInt(item.quantity, 10) || 0) + '|';
      }).join('');
    },

    /**
     * [RELEASE B] Re-render #pcv2-availability-config via the Section Rendering API.
     * Never rejects: resolves with the fresh minimum payload when both section
     * payloads rendered, or null when the response cannot be trusted.
     * Refreshes both server-owned payloads from the same section response.
     * @returns {Promise<Object|null>} fresh minimum-policy payload, or null
     */
    refreshAvailabilityPayload: function() {
      // [RELEASE B] Fetch even when the payload node is absent. Returning early on a
      // missing node meant the one situation where a refresh matters most - no
      // payload on the page - was also the one where we never tried to get one.
      // Locale-aware root: a hardcoded '/' fetches the EN render from /fr/ pages.
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root.replace(/\/$/, '') + '/?section_id=cart-availability';

      return fetch(url)
        .then(function(r) { return r.ok ? r.text() : null; })
        .then(function(html) {
          if (!html) return null;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.getElementById('pcv2-availability-config');
          if (!fresh) return null;
          var policyNode = parsed.getElementById('cart-minimum-policy');
          if (!policyNode) return null;
          try {
            var policy = JSON.parse(policyNode.textContent || '');
            if (typeof policy.has_gifting_merchandise !== 'boolean') return null;
            if (!Number.isFinite(Number(policy.total_price))) return null;
            if (typeof policy.cart_fingerprint !== 'string') return null;
            return { policy: policy, availabilityText: fresh.textContent };
          } catch (err) {
            return null;
          }
        })
        .catch(function(err) {
          console.warn('[SmartCart] Availability payload refresh failed:', err);
          return null;
        });
    },

    commitAvailabilityPayload: function(text) {
      var current = document.getElementById('pcv2-availability-config');
      if (current) {
        current.textContent = text;
      } else {
        var adopted = document.createElement('script');
        adopted.type = 'application/json';
        adopted.id = 'pcv2-availability-config';
        adopted.textContent = text;
        document.body.appendChild(adopted);
      }
    },

    /**
     * Update state from cart object
     */
    updateFromCart: function(cart, preservePolicyOnFailure, retryContext) {
      var self = this;
      var generation = retryContext ? retryContext.generation : ++this.state._policyGeneration;
      if (generation !== this.state._policyGeneration) return;
      var retriesRemaining = retryContext ? retryContext.retriesRemaining : 1;

      // Store previous stage for celebration detection
      this.state.previousStage = this.state.currentStage;
      var previousTotal = this.state.cartTotal;

      // Update cart total
      this.state.cartTotal = cart.total_price;
      var cartFingerprint = this.cartFingerprint(cart);
      this.state.cartItemCount = Number.isFinite(Number(cart.item_count))
        ? Number(cart.item_count)
        : cart.items.reduce(function(total, item) { return total + (parseInt(item.quantity, 10) || 0); }, 0);
      // Detect Prime product in cart
      this.state.cartHasPrimeProduct = cart.items.some(function(item) {
        return String(item.variant_id) === String(self.config.primeVariantId);
      });

      // Detect gifting items for Prime pricing (product_type proxy).
      // Pricing-only: delivery-date policy comes from the server-rendered
      // availability payload, never from this proxy - see validateStoredDeliveryDate.
      var hasGifts = false;
      var hasNonPrimeItem = false;
      cart.items.forEach(function(item) {
        if (String(item.variant_id) === String(self.config.primeVariantId)) return;
        hasNonPrimeItem = true;
        var type = (item.product_type || '').toLowerCase();
        if (type.indexOf('fresh') === -1) {
          hasGifts = true;
        }
      });

      // A cart holding only the Prime membership variant still counts as gifting
      if (!hasNonPrimeItem && cart.items.length > 0) {
        hasGifts = true;
      }
      this.state.cartHasGifts = hasGifts;

      // Legacy Prime + Gifts: free delivery (minimum basket still enforced)
      this.state.legacyFreeDelivery = this.state.isLegacyPrime && this.state.cartHasGifts;

      // Calculate current stage
      this.state.currentStage = this.getCurrentStage();

      // Update data attributes
      this.elements.container.dataset.currentStage = this.state.currentStage;
      this.elements.container.dataset.cartTotal = this.state.cartTotal;
      this.elements.container.dataset.cartHasPrimeProduct = this.state.cartHasPrimeProduct;
      this.elements.container.dataset.cartItemCount = this.state.cartItemCount;

      // Render appropriate stage
      this.render();

      // Monetary celebrations depend only on actual threshold crossings. A gift
      // policy refresh must never imply that the minimum itself was reached.
      if (!(retryContext && retryContext.suppressCelebration) && this.state.previousStage === 'STAGE_1' && previousTotal < this.config.minimumBasket && this.state.cartTotal >= this.config.minimumBasket) {
        this.celebrate('minimum');
      } else if (!(retryContext && retryContext.suppressCelebration) && this.state.currentStage === 'STAGE_2' && this.isEffectivePrime()) {
        var wasBelow = previousTotal < this.config.freeDeliveryThreshold;
        var isAbove = this.state.cartTotal >= this.config.freeDeliveryThreshold;
        if (wasBelow && isAbove) {
          this.celebrate('free-delivery');
        }
      }

      // Update checkout button
      this.updateCheckoutButton();

      // Update footer savings line (include Prime savings from data attribute)
      var primeSavings = 0;
      var footerEl = document.querySelector('[data-cart-footer-v2]');
      if (footerEl && footerEl.dataset.primeSavings) {
        primeSavings = parseInt(footerEl.dataset.primeSavings, 10) || 0;
      }
      var totalSavings = (cart.total_discount || 0) + primeSavings;
      this.updateFooterSavings(totalSavings);

      // The gift exemption cannot change checkout eligibility at or above the
      // minimum. A stored date still needs the refreshed availability payload.
      var storedDate = cart.attributes && cart.attributes['Delivery Date'];
      if (this.state.cartTotal >= this.config.minimumBasket && !storedDate) return;

      // Retain the last verified gift bit while this generation is pending. Only a
      // matching discounted total and ordered line fingerprint can replace it.
      this.refreshAvailabilityPayload().then(function(snapshot) {
        if (generation !== self.state._policyGeneration) return;
        var policy = snapshot && snapshot.policy;
        if (!policy) {
          if (!preservePolicyOnFailure) self.failMinimumPolicy(generation);
          return;
        }
        if (Number(policy.total_price) !== self.state.cartTotal || policy.cart_fingerprint !== cartFingerprint) {
          if (retriesRemaining > 0) {
            self.resyncMinimumPolicy(generation, preservePolicyOnFailure);
          } else if (!preservePolicyOnFailure) {
            self.failMinimumPolicy(generation);
          }
          return;
        }

        self.commitAvailabilityPayload(snapshot.availabilityText);
        self.state.hasGiftingMerchandise = policy.has_gifting_merchandise;
        self.state.currentStage = self.getCurrentStage();
        self.elements.container.dataset.hasGiftingMerchandise = self.state.hasGiftingMerchandise;
        self.elements.container.dataset.currentStage = self.state.currentStage;
        self.render();
        self.updateCheckoutButton();
        // Not on the pre-checkout page: that page judges the stored date itself, with
        // the same validator, and its Continue writes the delivery attributes. A clear
        // sent from here could land after that write and erase the date just saved.
        if (!document.querySelector('.pre-checkout-v2')) self.validateStoredDeliveryDate(cart, true);
      });
    },

    /**
     * [RELEASE B] Clear the stored delivery date when it is no longer valid for the
     * current cart, using the SAME rules pre-checkout applies. Delegating to the
     * shared DDMAvailability.validateCartDeliveryDate helper is what makes drawer /
     * pre-checkout parity structural rather than a pair of hand-synced checks.
     *
     * Replaces the previous product_type=='fresh' proxy gate plus Sunday-only test,
     * which cleared nothing for baby SKUs (their product_type is "Baby Care" and the
     * like, so the proxy said not-fresh and the check early-returned) and never
     * cleared a stored Saturday even though Fresh/Baby is Mon-Fri.
     *
     * Policy comes from the server-rendered availability payload (product metafields),
     * never from the forgeable _vertical line property.
     *
     * @param {Object} cart - The cart object
     */
    validateStoredDeliveryDate: function(cart, payloadIsFresh) {
      var storedDate = cart.attributes && cart.attributes['Delivery Date'];
      if (!storedDate) return;

      var DDM = window.DDMAvailability;
      if (!DDM || typeof DDM.validateCartDeliveryDate !== 'function') return;

      if (!payloadIsFresh) return;
      var payload = DDM.parseJSONScript('pcv2-availability-config');
      if (!payload || !payload.items) return;
      var result = DDM.validateCartDeliveryDate(payload, storedDate);
      if (!result.valid) {
        console.log('[SmartCart] Clearing delivery date - ' + result.reason);
        this.clearDeliveryDate();
      }
    },

    /**
     * [DODOFRESH] Clear delivery date cart attribute
     */
    clearDeliveryDate: function() {
      // [RELEASE B] Must clear the SAME attribute set as pre-checkout's
      // StateManager clear (pre-checkout-v2.js:333). Clearing only the date and
      // type left delivery_rate_at_selection and selection_timestamp behind, so the
      // two surfaces produced different cart state for the same operation.
      // pre-checkout reads delivery_rate_at_selection (:514) for rate-change
      // detection, and this clear now runs on every page load, so a stale rate
      // would persist into the next selection cycle.
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Delivery Date': '',
            'delivery_type': '',
            'delivery_rate_at_selection': '',
            'selection_timestamp': ''
          }
        })
      }).then(function() {
        console.log('[SmartCart] Delivery date cleared');
      }).catch(function(err) {
        console.error('[SmartCart] Failed to clear delivery date:', err);
      });
    },

    /**
     * Get current stage based on state
     */
    getCurrentStage: function() {
      if (this.state.cartItemCount <= 0) return 'STAGE_1';
      if (this.state.cartTotal < this.config.minimumBasket &&
          (this.state.cartTotal <= 0 || !this.state.hasGiftingMerchandise)) return 'STAGE_1';
      return 'STAGE_2';
    },

    /**
     * Get Stage 2 option (A = Prime, B = Non-Prime)
     */
    getStage2Option: function() {
      return this.isEffectivePrime() ? 'A' : 'B';
    },

    /**
     * Check if cart is effectively Prime
     */
    isEffectivePrime: function() {
      return this.state.isPrime || this.state.cartHasPrimeProduct;
    },

    /**
     * Render the appropriate stage UI
     */
    render: function() {
      var stage = this.state.currentStage;
      var option = this.getStage2Option();

      [this.elements.stage1, this.elements.stage2a, this.elements.stage2b].forEach(function(element) {
        if (!element) return;
        element.style.display = 'none';
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
      });

      if (stage === 'STAGE_1') {
        this.renderStage1();
      } else if (option === 'A') {
        this.renderStage2A();
      } else {
        this.renderStage2B();
      }
    },

    /**
     * Render Stage 1: Minimum basket progress
     */
    renderStage1: function() {
      if (!this.elements.stage1) return;
      this.elements.stage1.style.display = '';
      this.elements.stage1.hidden = false;
      this.elements.stage1.setAttribute('aria-hidden', 'false');

      var remaining = Math.max(0, this.config.minimumBasket - this.state.cartTotal);
      var progress = this.config.minimumBasket > 0
        ? Math.min(100, (this.state.cartTotal / this.config.minimumBasket) * 100)
        : 100;

      if (this.elements.stage1Message) {
        this.setMessageWithHighlights(this.elements.stage1Message, 'stage1_message', remaining);
      }

      if (this.elements.stage1Fill) {
        this.elements.stage1Fill.style.width = progress + '%';
      }
    },

    /**
     * Render Stage 2 Option A: Prime progress
     */
    renderStage2A: function() {
      if (!this.elements.stage2a) return;
      this.elements.stage2a.style.display = '';
      this.elements.stage2a.hidden = false;
      this.elements.stage2a.setAttribute('aria-hidden', 'false');

      var remaining = Math.max(0, this.config.freeDeliveryThreshold - this.state.cartTotal);
      var isComplete = remaining <= 0 || this.state.legacyFreeDelivery;

      var range = this.config.freeDeliveryThreshold - this.config.minimumBasket;
      var value = this.state.cartTotal - this.config.minimumBasket;
      var progress = range > 0 ? Math.min(100, Math.max(0, (value / range) * 100)) : 100;
      if (this.state.legacyFreeDelivery) progress = 100;

      var messageEl = this.elements.stage2aMessage;
      var progressFill = this.elements.stage2aFill;
      var savingsEl = this.elements.stage2aSavings;

      if (messageEl) {
        while (messageEl.firstChild) {
          messageEl.removeChild(messageEl.firstChild);
        }

        if (this.state.legacyFreeDelivery || isComplete) {
          messageEl.appendChild(this.createCheckIcon());
          messageEl.appendChild(document.createTextNode(' '));
          var text = this.state.legacyFreeDelivery ? this.t('legacy_message') : this.t('stage2a_complete');
          messageEl.appendChild(document.createTextNode(text));
          messageEl.classList.add('smart-cart__message--success');
        } else {
          this.setMessageWithHighlights(messageEl, 'stage2a_progress', remaining);
          messageEl.classList.remove('smart-cart__message--success');
        }
      }

      if (progressFill) {
        progressFill.style.width = progress + '%';
        if (isComplete) {
          progressFill.classList.add('smart-cart__progress-fill--complete');
        } else {
          progressFill.classList.remove('smart-cart__progress-fill--complete');
        }
      }

      if (savingsEl) {
        if (isComplete && !this.state.legacyFreeDelivery) {
          savingsEl.style.display = '';
          savingsEl.textContent = this.t('stage2a_savings');
        } else {
          savingsEl.style.display = 'none';
        }
      }
    },

    /**
     * Render Stage 2 Option B: Non-Prime promo
     */
    renderStage2B: function() {
      if (!this.elements.stage2b) return;
      this.elements.stage2b.style.display = '';
      this.elements.stage2b.hidden = false;
      this.elements.stage2b.setAttribute('aria-hidden', 'false');

      var checkbox = document.getElementById('SmartCartPrimeCheckbox');
      if (checkbox) {
        checkbox.checked = false;
        checkbox.disabled = false;
      }
    },

    /**
     * Set message with highlighted Rs values using safe DOM methods
     */
    setMessageWithHighlights: function(container, key, remaining) {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      var text = this.t(key);
      var formattedRemaining = this.formatMoney(remaining);
      text = text.replace('[remaining]', formattedRemaining);

      // Split by "Rs " prefix and rebuild with highlights
      var parts = text.split('Rs ');

      for (var i = 0; i < parts.length; i++) {
        if (i === 0) {
          if (parts[i]) {
            container.appendChild(document.createTextNode(parts[i]));
          }
        } else {
          // Find where the number ends
          var numEnd = 0;
          while (numEnd < parts[i].length && (parts[i][numEnd] >= '0' && parts[i][numEnd] <= '9' || parts[i][numEnd] === ',' || parts[i][numEnd] === ' ')) {
            numEnd++;
          }

          if (numEnd > 0) {
            var span = document.createElement('span');
            span.className = 'smart-cart__highlight';
            span.textContent = 'Rs ' + parts[i].substring(0, numEnd).trim();
            container.appendChild(span);

            if (numEnd < parts[i].length) {
              container.appendChild(document.createTextNode(parts[i].substring(numEnd)));
            }
          } else {
            container.appendChild(document.createTextNode('Rs ' + parts[i]));
          }
        }
      }
    },

    /**
     * Create checkmark SVG icon
     */
    createCheckIcon: function() {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'smart-cart__check');
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '3');

      var polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      polyline.setAttribute('points', '20 6 9 17 4 12');
      svg.appendChild(polyline);

      return svg;
    },

    /**
     * Update checkout button state
     */
    updateCheckoutButton: function() {
      var btn = this.elements.checkoutBtn;
      var textEl = this.elements.checkoutText;
      if (!btn) return;

      // Update subtotal on right side (use cached element)
      if (this.elements.checkoutSubtotal && typeof theme !== 'undefined' && theme.Currency) {
        this.elements.checkoutSubtotal.textContent = theme.Currency.formatMoney(this.state.cartTotal, theme.moneyFormat);
      }

      if (this.state.currentStage === 'STAGE_1') {
        var remaining = Math.max(0, this.config.minimumBasket - this.state.cartTotal);
        var remainingRs = Math.ceil(remaining / 100);

        btn.classList.add('cart__checkout--disabled');
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');

        if (textEl) {
          var text = this.t('button_add_to_checkout').replace('[remaining]', 'Rs ' + remainingRs);
          textEl.textContent = text;
        }
      } else {
        btn.classList.remove('cart__checkout--disabled');
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');

        if (textEl) {
          textEl.textContent = this.t('button_proceed');
        }
      }
    },

    /**
     * Update footer savings line
     */
    updateFooterSavings: function(totalDiscount) {
      if (!this.elements.savingsLine) return;

      if (totalDiscount > 0) {
        this.elements.savingsLine.style.display = '';
        if (this.elements.savingsAmount && typeof theme !== 'undefined' && theme.Currency) {
          this.elements.savingsAmount.textContent = theme.Currency.formatMoney(totalDiscount, theme.moneyFormat);
        }
      } else {
        this.elements.savingsLine.style.display = 'none';
      }
    },

    /**
     * Add DodoPrime membership to cart
     */
    addPrimeToCart: function() {
      var self = this;
      var checkbox = document.getElementById('SmartCartPrimeCheckbox');
      if (checkbox) checkbox.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: this.config.primeVariantId,
          quantity: 1
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Failed to add Prime');
        return r.json();
      })
      .then(function(item) {
        // Feeds the GA4/Ads add_to_cart listener (S7C-02) and rebuilds the
        // drawer via the CartDrawer listener (replaces cart:build — same
        // buildCart, one render). skipDrawer: drawer already open.
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: item, quantityAdded: 1, skipDrawer: true }
        }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function(err) {
        console.error('[SmartCart] Failed to add Prime:', err);
        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = false;
        }
      });
    },

    /**
     * Toggle tooltip visibility
     */
    toggleTooltip: function(icon) {
      var tooltip = this.elements.tooltip;
      var content = this.elements.tooltipContent;
      if (!tooltip || !content) return;

      var key = icon.dataset.tooltip;

      var keyMap = {
        'stage1': 'stage1_tooltip',
        'stage2a_progress': 'stage2a_tooltip_progress',
        'stage2a_complete': 'stage2a_tooltip_complete',
        'stage2b': 'stage2b_tooltip',
        'legacy': 'stage2a_tooltip_complete'
      };

      var text = this.t(keyMap[key] || key + '_tooltip');

      if (tooltip.style.display === '' && content.textContent === text) {
        this.hideTooltip();
        return;
      }

      content.textContent = text;
      tooltip.style.display = '';

      var isMobile = window.innerWidth < 768;
      if (isMobile) {
        tooltip.style.position = 'relative';
        tooltip.style.marginTop = '8px';
        var self = this;
        setTimeout(function() { self.hideTooltip(); }, 5000);
      } else {
        var rect = icon.getBoundingClientRect();
        var containerRect = this.elements.container.getBoundingClientRect();
        tooltip.style.position = 'absolute';
        tooltip.style.top = (rect.bottom - containerRect.top + 8) + 'px';
        tooltip.style.right = '0';
        tooltip.style.marginTop = '0';
      }
    },

    /**
     * Hide tooltip
     */
    hideTooltip: function() {
      if (this.elements.tooltip) {
        this.elements.tooltip.style.display = 'none';
      }
    },

    /**
     * Celebration animation
     */
    celebrate: function(type) {
      var container = this.elements.container;
      if (!container) return;

      container.classList.add('smart-cart--celebrating');
      setTimeout(function() {
        container.classList.remove('smart-cart--celebrating');
      }, 600);
    },

    /**
     * Get translation string
     */
    t: function(key) {
      var strings = window.smartCartStrings || {};
      return strings[key] || key;
    },

    /**
     * Format money value
     */
    formatMoney: function(cents) {
      var amount = Math.ceil(cents / 100);
      if (amount >= 1000) {
        return 'Rs ' + amount.toLocaleString('en-MU');
      }
      return 'Rs ' + amount;
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      SmartCartProgress.init();
    });
  } else {
    SmartCartProgress.init();
  }

  // Expose via namespaced global (DodoPrime initialized in theme.liquid)
  window.DodoPrime = window.DodoPrime || {};
  window.DodoPrime.SmartCart = SmartCartProgress;
})();
